<template>
	<div class="general">
		<v-tabs
			vertical
			left
			color="primary"
			slider-color="primary"
			background-color="secondary"
			active-class="primary--text"
			style="border-radius: 4px"
			v-model="tabOpen"
		>
			<v-tab class="text-caption" v-if="!isExternalEntity">
				<span v-if="$store.getters.hasRole('manager')" v-translate>Administrator</span>
				<span v-else v-translate>User</span>
			</v-tab>
			<v-tab class="text-caption" v-translate v-else>Entity</v-tab>
			<v-tab class="text-caption" v-translate>Platform</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager">Specialities</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager">Patients</v-tab>
			<!-- <v-tab class="text-caption" v-translate v-if="isTerapeut">Prescription</v-tab> -->
			<v-tab class="text-caption" v-translate v-if="isTerapeut">Monitoring</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager">Consents</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager" href="#appointment_types">Appointment Type</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager" href="#pricing">Pricing</v-tab>
			<v-tab class="text-caption" v-translate v-if="isManager" href="#email_sms">Email & SMS</v-tab>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="!isExternalEntity">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate v-if="$store.getters.hasRole('manager')">Administrator</translate>
							<translate v-else>User</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showGeneralForm = !showGeneralForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showGeneralForm">
						<v-row no-gutters class="my-2">
							<span class="text-subtitle-1 font-weight-regular primary--text">
								<translate>Login Info</translate>
							</span>
						</v-row>
						<v-divider class="mb-4"></v-divider>
						<v-row no-gutters>
							<v-col>
								<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
									<v-list-item-content>
										<v-list-item-title>
											<span>
												<translate>Name</translate>
											</span>
											<span class="grey--text" style="float: right">{{info.user_info.name ? info.user_info.name : '---'}}</span>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
									<v-list-item-content>
										<v-list-item-title>
											<span>
												<translate>Email</translate>
											</span>
											<span class="grey--text" style="float: right">{{info.user_info.email ? info.user_info.email : '---'}}</span>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="$store.getters.hasRole('manager')" class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
									<v-list-item-content>
										<v-list-item-title>
											<span>
												<translate>Phone</translate>
											</span>
											<span class="grey--text" style="float: right">
												{{info.user_info.space.phone ? info.user_info.space.phone : '---'}}
											</span>
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<template v-if="info.user_info.student">
									<v-list-item class="mb-1 mt-3" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>School</translate>
												</span>
												<span class="grey--text" style="float: right">{{info.user_info.school}}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>Student Number</translate>
												</span>
												<span class="grey--text" style="float: right">
													<v-icon small v-if="info.user_info.student_proof">mdi-check-circle</v-icon>
													<v-icon class="mb-1" small v-else>mdi-help-circle</v-icon>
													{{info.user_info.student_number ? info.user_info.student_number : '---'}}
												</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
								<template v-if="$store.getters.hasRole('terapeut') && false">
									<v-list-item class="mb-1 mt-3" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>Specialities</translate>
												</span>
												<span style="float: right" class="grey--text" v-if="info.user_info.specialities.length == 0" v-translate>No specialities.</span>
												<v-chip
													small
													v-else
													v-for="spec in info.user_info.specialities"
													class="grey--text ml-1"
													style="float: right"
													:key="spec.id"
												>{{spec.name}}</v-chip>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>Professional License Number</translate>
												</span>
												<span class="grey--text" style="float: right">{{info.user_info.license_number ? info.user_info.license_number : '---'}}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-col>
							<v-col v-if="$store.getters.hasRole('manager')" :cols="2" class="pa-5">
								<v-row no-gutters align="center" justify="center">
									<v-img
										:src="info.user_info.space.logo_url ? info.user_info.space.logo_url : require('../../assets/images/' + logoName)"
										contain
										max-height="110"
									/>
								</v-row>
							</v-col>
						</v-row>
						<template v-if="$store.getters.hasRole('manager')">
							<v-row no-gutters class="my-2">
								<span class="text-subtitle-1 font-weight-regular primary--text">
									<translate>Facturation Info</translate>
								</span>
							</v-row>
							<v-divider class="mb-4"></v-divider>
							<v-row no-gutters class="mt-3">
								<v-col cols="12">
									<!-- <v-list-item class="mt-3 mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>Establishment Name</translate>
												</span>
												<span class="grey--text" style="float: right">{{info.user_info.space.space_name ? info.user_info.space.space_name : '---'}}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item> -->
									<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>Company Name / Individual Name</translate>
												</span>
												<span class="grey--text" style="float: right">{{info.user_info.space.company_name ? info.user_info.space.company_name : '---'}}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
										<v-list-item-content>
											<v-list-item-title>
												<span>
													<translate>VAT Number</translate>
												</span>
												<span class="grey--text" style="float: right">{{info.user_info.space.company_nif ? info.user_info.space.company_nif : '---'}}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-col>
								<!-- <v-col cols="3" class="pa-5">
									<v-row no-gutters align="center" justify="center">
										<v-img
											:src="info.user_info.space.logo_url ? info.user_info.space.logo_url : require('../../assets/images/' + logoName)"
											contain
											max-height="110"
										/>
									</v-row>
								</v-col> -->
							</v-row>
						</template>
					</template>
					<template v-else>
						<v-row no-gutters class="my-2">
							<span class="text-subtitle-1 font-weight-regular primary--text">
								<translate>Login Info</translate>
							</span>
						</v-row>
						<v-divider class="mb-4"></v-divider>
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.name"
										:label="$gettext('Name')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.email"
										:label="$gettext('Email')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<template v-if="$store.getters.hasRole('manager')">
									<v-col cols="6" no-gutters>
										<v-text-field
											v-model="info.user_info.space.phone"
											:label="$gettext('Phone')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="6"></v-col>
								</template>
								<template v-if="info.user_info.student">
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="info.user_info.school"
											:label="$gettext('School')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="info.user_info.student_number"
											:label="$gettext('Student Number')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="6" offset="6" class="mb-4">
										<VueFileAgent
											v-if="!info.user_info.student_proof"
											:theme="'list'"
											:multiple="false"
											:deletable="true"
											:meta="true"
											:accept="'image/*,.pdf'"
											:maxSize="'50MB'"
											:helpText="$gettext('Drag or click to add proof of enrollment')"
											:errorText="{
												type: 'Invalid file type',
												size: 'Files cannot exceed 50MB in size'
											}"
																	@select="fileSelected($event, false)"
											@beforedelete="studentProof = null"
											v-model="studentProof"
										></VueFileAgent>
										<template v-else>
											<v-btn
												color="primary"
												text
												@click="openFile(info.user_info.student_proof)"
												small
											>
												<translate>Proof of enrollment</translate>
												<v-icon small class="ml-1">mdi-receipt</v-icon>
											</v-btn>
											<v-btn
												color="primary"
												icon
												@click="removeProof"
												small
											>
												<v-icon small>mdi-delete</v-icon>
											</v-btn>
										</template>
									</v-col>
								</template>
								<template v-if="$store.getters.hasRole('terapeut') && false">
									<v-col cols="12" sm="6">
										<v-select
											v-model="info.user_info.specialities"
											:items="info.specialities"
											:label="$gettext('Specialities')"
											item-text="name"
											item-value="id"
											outlined
											multiple
											return-object
											class="px-2"
										></v-select>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="info.user_info.license_number"
											:label="$gettext('Professional License Number')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
								</template>
								<template v-if="$store.getters.hasRole('manager')">
									<v-col cols="12" sm="6">
										<!-- <v-text-field
											v-model="info.user_info.space.space_name"
											:label="$gettext('Establishment Name')"
											outlined
											class="px-2"
										></v-text-field> -->
									</v-col>
									<v-col cols="12" md="6">
										<v-row no-gutters class="mb-2">
											<v-col cols="12">
												<v-img
													:src="info.user_info.space.logo_url ? info.user_info.space.logo_url : require('../../assets/images/' + logoName)"
													contain
													height="125"
												/>
											</v-col>
											<v-col cols="12" v-if="info.user_info.space.logo_url">
												<v-btn large icon @click="removeAdminLogo" style="float: right">
													<v-icon color="primary">delete</v-icon>
												</v-btn>
											</v-col>
										</v-row>
										<v-row v-if="!info.user_info.space.logo_url" no-gutters align="center" class="mb-5">
											<v-col>
												<VueFileAgent
													:theme="'list'"
													:multiple="false"
													:deletable="true"
													:meta="true"
													:accept="'image/*'"
													:maxSize="'50MB'"
													:helpText="$gettext('Drag or click')"
													:errorText="{
														type: 'Invalid file type. Only images are allowed',
														size: 'Files cannot exceed 50MB in size'
													}"
																				@select="fileSelected($event, true)"
													@beforedelete="adminLogo = null"
													v-model="adminLogo"
													>
												</VueFileAgent>
											</v-col>
										</v-row>
									</v-col>
									<v-col cols="12">
										<v-row no-gutters class="my-2">
											<span class="text-subtitle-1 font-weight-regular primary--text">
												<translate>Facturation Info</translate>
											</span>
										</v-row>
										<v-divider class="mb-4"></v-divider>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="info.user_info.space.company_name"
											:label="$gettext('Company Name / Individual Name')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field
											v-model="info.user_info.space.company_nif"
											:label="$gettext('VAT Number')"
											outlined
											class="px-2"
										></v-text-field>
									</v-col>
								</template>
								<v-col cols="12" class="mb-2">
									<v-row no-gutters>
										<v-btn color="primary" @click="showChangePassword = !showChangePassword">
											<translate>Change Password</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn color="primary" @click="showGeneralForm = !showGeneralForm">
											<translate>Cancel</translate>
										</v-btn>
										<v-btn color="primary" class="ml-2" @click="editUserInfo">
											<translate>Save</translate>
										</v-btn>
									</v-row>
								</v-col>
								<v-form ref="changePasswordForm" v-model="changePasswordFormValid">
									<v-row v-if="showChangePassword" no-gutters class="mt-6">
										<v-col cols="12">
											<v-col cols="12" sm="6" class="ma-0 pa-0">
												<v-alert v-model="showChangePasswordError" color="red" icon="warning">
													<translate>Password incorrect</translate>
												</v-alert>
											</v-col>
										</v-col>
										<v-col cols="12">
											<v-col cols="12" sm="6" class="ma-0 pa-0">
												<v-text-field
													v-model="current_pwd"
													:label="$gettext('Current Password')"
													outlined
													class="px-2"
													type="password"
													:rules="[required, passwordRule]"
												></v-text-field>
											</v-col>
										</v-col>
										<v-col cols="12">
											<v-col cols="12" sm="6" class="ma-0 pa-0">
												<v-text-field
													v-model="new_pwd"
													:label="$gettext('New Password')"
													outlined
													class="px-2"
													type="password"
													:rules="[required, passwordRule]"
												></v-text-field>
											</v-col>
										</v-col>
										<v-col cols="12" class="mb-2">
											<v-col cols="12" sm="6" class="ma-0 pa-0">
												<v-text-field
													v-model="repeat_pwd"
													:label="$gettext('Repeat New Password')"
													outlined
													class="px-2"
													type="password"
													:rules="[required, equalTo]"
												></v-text-field>
												<v-btn color="primary" class="float-right" @click="changePassword">
													<translate>Save</translate>
												</v-btn>
											</v-col>
										</v-col>
									</v-row>
								</v-form>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-else>
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Entity</translate>
							<v-btn color="primary" fab x-small class="my-1 ml-2" @click="showEntityForm = !showEntityForm">
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showEntityForm">
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Name</translate>
									</span>
									<span class="grey--text" style="float: right">{{info.user_info.space.external_entity.name ? info.user_info.space.external_entity.name : '---'}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Address</translate>
									</span>
									<span class="grey--text" style="float: right">{{info.user_info.space.external_entity.address ? info.user_info.space.external_entity.address : '---'}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Phone</translate>
									</span>
									<span class="grey--text" style="float: right">{{info.user_info.space.external_entity.phone ? info.user_info.space.external_entity.phone : '---'}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Email</translate>
									</span>
									<span class="grey--text" style="float: right">{{info.user_info.space.external_entity.email ? info.user_info.space.external_entity.email : '---'}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Products</translate>
									</span>
									<template v-if="info.user_info.space.external_entity.cmm || info.user_info.space.external_entity.supp">
										<v-chip
											v-if="info.user_info.space.external_entity.cmm"
											small
											class="grey--text ml-1"
											style="float: right"
											key="cmm"
										><translate>Chinese Materia Medica</translate></v-chip>
										<v-chip
											v-if="info.user_info.space.external_entity.supp"
											small
											class="grey--text ml-1"
											style="float: right"
											key="supp"
										><translate>Supplements</translate></v-chip>
									</template>
									<span v-else class="grey--text" style="float: right">---</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Description</translate>
									</span>
									<span class="grey--text" style="float: right; white-space: pre-wrap">{{info.user_info.space.external_entity.description ? info.user_info.space.external_entity.description : '---'}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-alert
							v-if="!$store.getters.externalEntity.verified"
							border="bottom"
							colored-border
							type="warning"
							elevation="2"
							class="mt-2"
						>
							<translate>Your entity is not yet verified. Wait until you are verified to add supplements and chinese materia medica.</translate>
						</v-alert>
					</template>
					<template v-else>
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.space.external_entity.name"
										:label="$gettext('Name')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.space.external_entity.address"
										:label="$gettext('Address')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.space.external_entity.phone"
										:label="$gettext('Phone')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="6">
									<v-text-field
										v-model="info.user_info.space.external_entity.email"
										:label="$gettext('Email')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-textarea
										v-model="info.user_info.space.external_entity.description"
										:label="$gettext('Description')"
										outlined
										auto-grow
										class="px-2"
									></v-textarea>
								</v-col>
								<v-col cols="12">
									<span v-translate class="primary--text">Products</span>
									<v-row no-gutters>
										<v-checkbox
											v-model="info.user_info.space.external_entity.cmm"
											:label="$gettext('Chinese Materia Medica')"
										/>
										<v-checkbox
											v-model="info.user_info.space.external_entity.supp"
											:label="$gettext('Supplements')"
											class="ml-3"
										/>
									</v-row>
								</v-col>
								<v-col cols="12" class="mb-2">
									<v-row no-gutters>
										<v-btn color="primary" @click="showEntityForm = !showEntityForm">
											<translate>Cancel</translate>
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn color="primary" class="ml-2" @click="editExternalEntity">
											<translate>Save</translate>
										</v-btn>
									</v-row>
								</v-col>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Platform</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showPlatformForm = !showPlatformForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showPlatformForm">
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Language</translate>
									</span>
									<span class="grey--text" style="float: right">{{languageName}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Color</translate>
									</span>
									<span class="grey--text" style="float: right">
										<v-chip x-small :color="info.user_info.platform_color"></v-chip>
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<template v-if="!isExternalEntity">
							<p class="mt-3 mb-2">
								<b v-translate>Schedule</b>
							</p>
							<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
								<v-list-item-content>
									<v-list-item-title>
										<span>
											<translate>Daily Hour Period</translate>
										</span>
										<span
											class="grey--text"
											style="float: right"
										>{{info.user_info.calendar_min}}h - {{info.user_info.calendar_max}}h</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
								<v-list-item-content>
									<v-list-item-title>
										<span>
											<translate>Make visible</translate>
										</span>
										<v-chip class="grey--text ml-1" v-if="info.user_info.show_saturday" small style="float: right">
											<translate>Saturday</translate>
										</v-chip>
										<v-chip class="grey--text ml-1" v-if="info.user_info.show_sunday" small style="float: right">
											<translate>Sunday</translate>
										</v-chip>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="$store.getters.hasRole('manager')" class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
								<v-list-item-content>
									<v-list-item-title>
										<span>
											<translate>Appointment Duration Interval</translate>
										</span>
										<v-chip class="grey--text ml-1" small style="float: right">
											{{$store.getters.appDurationInterval}} min
										</v-chip>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="$store.getters.hasRole('manager')" class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
								<v-list-item-content>
									<v-list-item-title>
										<span>
											<translate>Import drugs from previous appointment</translate>
										</span>
										<v-chip class="grey--text ml-1" small style="float: right">
											<span v-if="$store.getters.autoDrugImport" v-translate>Yes</span>
											<span v-else v-translate>No</span>
										</v-chip>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
					</template>
					<template v-else>
						<v-form ref="platformForm">
							<v-row no-gutters>
								<v-col cols="12" lg="3" md="5">
									<v-select
										v-model="info.user_info.language"
										:items="availableLanguages"
										:label="$gettext('Language')"
										item-text="name"
										item-value="code"
										outlined
										class="px-2"
									></v-select>
								</v-col>
								<v-col cols="12" lg="3" md="5">
									<v-select
										v-model="info.user_info.platform_color"
										:items="availableColors"
										:label="$gettext('Color Scheme')"
										item-text="name"
										item-value="value"
										outlined
										class="px-2"
										@change="changeColor(false)"
										return-object
									>
										<template slot="item" slot-scope="{ item }">
											<v-list-item-content :class="item.value"></v-list-item-content>
										</template>
										<template v-slot:selection="{ item }">
											<v-list-item-content no-gutters :class="item.value"></v-list-item-content>
											<span class="ml-2">{{item.name}}</span>
										</template>
									</v-select>
								</v-col>
								<template v-if="!isExternalEntity">
									<v-col cols="12" sm="12" class="text-subtitle-2 mb-3">
										<b v-translate>Daily hour period</b>
									</v-col>
									<v-col cols="12" sm="3">
										<v-select
											v-model="info.user_info.calendar_min"
											:items="availableMinHours"
											:label="$gettext('Start')"
											item-text="name"
											item-value="value"
											outlined
											class="px-2"
											:rules="[required]"
										></v-select>
									</v-col>
									<v-col cols="12" sm="3">
										<v-select
											v-model="info.user_info.calendar_max"
											:items="availableMaxHours"
											:label="$gettext('End')"
											item-text="name"
											item-value="value"
											outlined
											class="px-2"
											:rules="[required]"
										></v-select>
									</v-col>
									<v-col cols="12" sm="12" class="text-subtitle-2 mb-3">
										<b v-translate>Make visible</b>
									</v-col>
									<v-row no-gutters>
										<v-checkbox
											v-model="info.user_info.show_saturday"
											:label="$gettext('Saturday')"
											color="primary"
											class="my-0"
										></v-checkbox>
										<v-checkbox
											v-model="info.user_info.show_sunday"
											:label="$gettext('Sunday')"
											color="primary"
											class="my-0 ml-3"
										></v-checkbox>
									</v-row>
									<template v-if="$store.getters.hasRole('manager')">
										<v-col cols="12" sm="12" class="text-subtitle-2 mb-3">
											<b v-translate>Appointment</b>
										</v-col>
										<v-col cols="4" class="mt-3">
											<v-row no-gutters>
												<v-text-field
													v-model="info.user_info.space.app_duration_interval"
													:label="$gettext('Interval') + ' (' + $gettext('Minutes') + ')'"
													outlined
													:rules="[required, isInteger]"
												></v-text-field>
											</v-row>
										</v-col>
										<v-col cols="12" class="mt-3">
											<v-checkbox
												v-model="info.user_info.space.auto_drug_import"
												:label="$gettext('Import drugs from previous appointment')"
												color="primary"
												class="my-0 ml-3"
											></v-checkbox>
										</v-col>
									</template>
								</template>
								<v-col cols="12" class="my-2">
									<v-btn color="primary" @click="cancelEditPlatform">
										<translate>Cancel</translate>
									</v-btn>
									<v-btn color="primary" class="float-right" @click="editPlatform">
										<translate>Save</translate>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="isManager">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="text-h6 font-weight-regular primary--text" v-translate>Specialities</span>
					</v-row>
					<v-btn fab class="mb-3" color="primary" @click="showNewSpeciality = true" small>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
					<p v-if="info.specialities.length == 0" class="font-weight-thin ml-2" v-translate>No specialities.</p>
					<v-list v-else flat>
						<SpecialityItem
							v-for="speciality in info.specialities"
							:key="speciality.id"
							:speciality="speciality"
							@remove-speciality="removeSpeciality"
						/>
					</v-list>
					<v-dialog v-model="showNewSpeciality" max-width="40%">
						<v-card>
							<v-card-title class="primary--text mb-3 secondary">
								<v-icon color="primary" class="mr-2">mdi-certificate-outline</v-icon>
								<translate>New Speciality</translate>
							</v-card-title>
							<v-card-text>
								<v-row no-gutters>
									<v-col cols="12">
										<v-form ref="newSpecialityForm">
											<v-text-field
												v-model="newSpecialityName"
												:label="$gettext('Name')"
												outlined
												class="px-2"
												:rules="[required]"
											></v-text-field>
										</v-form>
									</v-col>
								</v-row>
							</v-card-text>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn color="primary" text @click="showNewSpeciality = false">
									<translate>Cancel</translate>
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn color="primary" text @click="addSpeciality" :loading="savingSpeciality">
									<translate>Create</translate>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="isManager">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Import Patients</translate>
						</span>
						<v-btn class="float-right" icon @click="showImportPatientsInfo = true">
							<v-icon color="primary">info_outline</v-icon>
						</v-btn>
						<v-dialog v-model="showImportPatientsInfo" max-width="40%">
							<v-card>
								<v-card-title class="title primary--text mb-2 secondary">
									<translate>Import Patients</translate>
								</v-card-title>
								<v-card-text>
									<p
										v-translate
									>This funccionality allows you to import a large ammount of new patients at once using an Excel file. Follow these 3 simple steps:</p>
									<p>
										<b>1.</b>
										<translate>Download the template file clicking the template button</translate>.
									</p>
									<p>
										<b>2.</b>
										<translate>Open the file and add a new row for every new patient you want to create. Fill every column with the respective information, just like the example provided. Note that only the name of the patient is mandatory and you can edit all the information later, just like any other patient created manually. Also don't forget to remove the example.</translate>
									</p>
									<p>
										<b>3.</b>
										<translate>Upload the file using the import option</translate>.
									</p>
								</v-card-text>
								<v-divider></v-divider>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="primary darken-1" text @click="showImportPatientsInfo = false">
										<translate>Close</translate>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-row>
					<v-row no-gutters align="center">
						<v-col cols="12" md="12">
							<v-btn color="primary" @click="downloadTemplate">
								<translate>Template</translate>
								<v-icon class="ml-2">mdi-download-outline</v-icon>
							</v-btn>
						</v-col>
						<v-col cols="12" md="12" class="mt-2">
							<v-btn color="primary" @click="showImportInput = !showImportInput">
								<translate>Import</translate>
								<v-icon class="ml-2">mdi-import</v-icon>
							</v-btn>
						</v-col>
						<v-row v-if="showImportInput" no-gutters class="mt-3" align="center">
							<v-col cols="12" md="7" lg="5">
								<v-form ref="importPatientsForm">
									<v-file-input
										:label="$gettext('Excel File')"
										outlined
										class="px-2"
										v-model="patientsExcel"
										hide-details
										:rules="[required]"
									></v-file-input>
								</v-form>
							</v-col>
							<v-col cols="12" md="2">
								<v-btn large icon @click="importPatients" :loading="loadingImportPatients">
									<v-icon color="primary">mdi-send</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-col cols="12" md="12">
							<v-alert
								v-model="successImport"
								:type="numPatientsImported > 0 ? 'success' : 'error'"
								class="ml-3 mt-3"
							>
								{{numPatientsImported}}
								<translate>Patients Imported</translate>
								<template v-if="existPatients.length > 0">
									<p class="mt-3" v-translate>Patients whose name already exists:</p>
									<p v-for="p in existPatients" :key="p[0]">{{p[0]}}</p>
								</template>
								<template v-if="invalidDatePatients.length > 0">
									<p class="mt-3" v-translate>Patients with invalid birthdays:</p>
									<p v-for="p in invalidDatePatients" :key="p">{{p}}</p>
								</template>
							</v-alert>
						</v-col>
					</v-row>
					<v-divider class="mt-4"></v-divider>
					<div class="mt-4">
						<span class="title font-weight-regular primary--text">
							<translate>Deleted Patients</translate>
						</span>
						<p
							v-if="info.deleted_patients.length == 0"
							class="font-weight-thin ml-2 mt-2"
							v-translate
						>No deleted patients.</p>
						<v-list v-else flat>
							<PatientItem v-for="patient in info.deleted_patients" :patient="patient" :key="patient.id" @delete="deletePatient" @restore="restorePatient" />
						</v-list>
					</div>
				</div>
			</v-tab-item>
			<!-- <v-tab-item :transition="false" :reverse-transition="false" v-if="isTerapeut">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Prescription</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showPrescriptionForm = !showPrescriptionForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showPrescriptionForm">
						<v-list-item
							v-if="info.prescription_info.prescription_header"
							class="mb-1"
							style="border-radius: 5px; border: 1px solid #e3e3e3"
						>
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Prescription Header</translate>
									</span>
									<span class="grey--text" style="float: right">
										<pre>{{info.prescription_info.prescription_header}}</pre>
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item
							v-if="info.prescription_info.prescription_footer"
							class="mb-1"
							style="border-radius: 5px; border: 1px solid #e3e3e3"
						>
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Prescription Footer</translate>
									</span>
									<span class="grey--text" style="float: right">
										<pre>{{info.prescription_info.prescription_footer}}</pre>
									</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item
							v-if="info.prescription_info.prescription_letterhead"
							class="mb-1"
							style="border-radius: 5px; border: 1px solid #e3e3e3"
						>
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Letterhead height (mm)</translate>
									</span>
									<span
										class="grey--text"
										style="float: right"
									>{{info.prescription_info.prescription_letterhead_height}}</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-row no-gutters>
							<v-col cols="3">
								<v-row no-gutters class="pa-1">
									<v-img
										:src="info.prescription_info.prescription_logo_url ? info.prescription_info.prescription_logo_url : require('../../assets/images/' + logoName)"
										contain
										max-height="110"
									/>
								</v-row>
							</v-col>
						</v-row>
					</template>
					<template v-else>
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" sm="12">
									<v-checkbox
										v-model="info.prescription_info.prescription_letterhead"
										:label="$gettext('Letterhead Paper')"
										color="primary"
										class="my-0"
									></v-checkbox>
								</v-col>
								<v-col v-if="info.prescription_info.prescription_letterhead" cols="12" md="4">
									<v-text-field
										v-model="info.prescription_info.prescription_letterhead_height"
										:label="$gettext('Letterhead height (mm)')"
										outlined
										class="px-2"
									></v-text-field>
								</v-col>
								<template v-else>
									<v-col cols="12" md="6" class="pl-2">
										<v-textarea
											outlined
											:label="$gettext('Prescription Header')"
											v-model="info.prescription_info.prescription_header"
										></v-textarea>
									</v-col>
									<v-col cols="12" md="6" class="pl-2">
										<v-textarea
											outlined
											:label="$gettext('Prescription Footer')"
											v-model="info.prescription_info.prescription_footer"
										></v-textarea>
									</v-col>
									<v-col cols="12" md="6" class="pl-2 mb-4">
										<v-row no-gutters justify="center" class="pa-4">
											<v-col cols="12">
											<v-img
												:src="info.prescription_info.prescription_logo_url ? info.prescription_info.prescription_logo_url : require('../../assets/images/' + logoName)"
												contain
												height="125"
											/>
											</v-col>
											<v-col cols="12" v-if="info.prescription_info.prescription_logo_url">
												<v-btn large icon @click="removePrescriptionLogo" style="float: right">
													<v-icon color="primary">delete</v-icon>
												</v-btn>
											</v-col>
										</v-row>
										<v-row no-gutters align="center" class="mb-5">
											<v-col>
												<VueFileAgent
                          :theme="'list'"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :accept="'image/*'"
                          :maxSize="'50MB'"
                          :helpText="$gettext('Drag or click')"
                          :errorText="{
                            type: 'Invalid file type. Only images are allowed',
                            size: 'Files cannot exceed 50MB in size'
                          }"
													@select="!$event[0].error ? prescriptionLogo = $event[0] : null"
                          @beforedelete="prescriptionLogo = null"
                          v-model="prescriptionLogo"
                        ></VueFileAgent>
											</v-col>
										</v-row>
									</v-col>
								</template>
								<v-col cols="12" class="mb-2">
									<v-btn color="primary" @click="showPrescriptionForm = !showPrescriptionForm">
										<translate>Cancel</translate>
									</v-btn>
									<v-btn color="primary" class="float-right" @click="editPrescription">
										<translate>Save</translate>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item> -->
			<v-tab-item :transition="false" :reverse-transition="false" v-if="isTerapeut">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Monitoring</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showMonitoringForm = !showMonitoringForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showMonitoringForm">
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Monitoring Email Body</translate>
									</span>
								</v-list-item-title>
								<span
									class="grey--text mt-2"
									style="white-space: pre-wrap"
								>{{info.user_info.monitoring_email_body}}</span>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-form>
							<v-row no-gutters>
								<template>
									<v-col cols="12" md="12" class="pl-2">
										<v-textarea
											outlined
											:label="$gettext('Monitoring Email Body')"
											v-model="info.user_info.monitoring_email_body"
											auto-grow
										></v-textarea>
									</v-col>
								</template>
								<v-col cols="12" class="mb-2">
									<v-btn color="primary" @click="showMonitoringForm = !showMonitoringForm">
										<translate>Cancel</translate>
									</v-btn>
									<v-btn color="primary" class="float-right" @click="editMonitoring">
										<translate>Save</translate>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" v-if="isManager">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Data Consent</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showDataConsentForm = !showDataConsentForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showDataConsentForm">
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<span v-translate class="mb-2 font-weight-bold">Older</span>
								<div v-if="info.user_info.space.data_consent_text" v-html="info.user_info.space.data_consent_text"/>
								<p v-else class="font-weight-thin ml-2" v-translate>Not defined</p>
								<span v-translate class="my-2 font-weight-bold">Minor</span>
								<div v-if="info.user_info.space.data_consent_minor_text" v-html="info.user_info.space.data_consent_minor_text"/>
								<p v-else class="font-weight-thin ml-2" v-translate>Not defined</p>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-form>
							<v-row no-gutters>
								<template>
									<v-col cols="12" md="12" class="pl-2">
										<span v-translate class="font-weight-bold">Older</span>
										<RichTextEditor class="my-2" key="data-older" ref="dataConsentOlder" :consentType="'data'" :consent="true" :text="info.user_info.space.data_consent_text" />
									</v-col>
									<v-col cols="12" md="12" class="pl-2">
										<span v-translate class="font-weight-bold">Minor</span>
										<RichTextEditor class="mt-2" key="data-minor" ref="dataConsentMinor" :consentType="'data'" :isMinor="true" :consent="true" :text="info.user_info.space.data_consent_minor_text" />
									</v-col>
								</template>
								<v-col cols="12" sm="12" class="mt-4">
									<v-btn color="primary" @click="showDataConsentForm = !showDataConsentForm">
										<translate>Cancel</translate>
									</v-btn>
									<v-btn color="primary" class="float-right" @click="editDataConsent">
										<translate>Save</translate>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</template>
					<v-row no-gutters class="my-3">
						<span class="title font-weight-regular primary--text">
							<translate>Terapeutic Consents</translate>
						</span>
					</v-row>
					<v-row no-gutters class="my-3">
						<span class="text-subtitle-1 font-weight-regular primary--text">
							<translate>Specialities</translate>
						</span>
					</v-row>
					<v-divider class="mb-2"></v-divider>
					<p
						v-if="info.specialities.length == 0"
						class="font-weight-thin ml-2"
						v-translate
					>No specialities.</p>
					<v-list v-else flat>
						<SpecialityItem
							v-for="speciality in info.specialities"
							:key="speciality.id"
							:speciality="speciality"
							:consent="true"
						/>
					</v-list>
					<v-row no-gutters class="my-3">
						<span class="text-subtitle-1 font-weight-regular primary--text">
							<translate>Others</translate>
						</span>
					</v-row>
					<v-divider class="mb-2"></v-divider>
					<v-btn
						small
						fab
						class="mb-3"
						color="primary"
						@click="showNewPremadeConsent = !showNewPremadeConsent"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
					<v-form v-if="showNewPremadeConsent" ref="newPreMadeConsentForm" class="mb-5">
						<v-row no-gutters>
              <v-col cols="6">
								<v-text-field
									v-model="newPreMadeConsent.title"
									:label="$gettext('Name')"
									outlined
									:rules="[required]"
								></v-text-field>
							</v-col>
              <v-col cols="12" class="mb-3">
                <h3 v-translate>Consent</h3>
              </v-col>
              <v-col cols="12">
                <span v-translate class="font-weight-bold">Older</span>
                <RichTextEditor class="mt-2" ref="editorPreMadeOlder" :consent="true" :text="newPreMadeConsent.consent_text" />
              </v-col>
              <v-col cols="12" class="my-2">
                <span v-translate class="font-weight-bold">Minor</span>
                <RichTextEditor class="mt-2" ref="editorPreMadeMinor" :consent="true" :isMinor="true" :text="newPreMadeConsent.consent_minor_text" />
              </v-col>
							<v-col cols="12" class="mt-5">
								<v-btn color="primary" @click="showNewPremadeConsent = !showNewPremadeConsent">
									<translate>Cancel</translate>
								</v-btn>
								<v-btn color="primary" class="float-right" @click="createPreMadeConsent">
									<translate>Save</translate>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
					<p
						v-if="info.user_info.space.pre_made_consents.length == 0"
						class="font-weight-thin ml-2"
						v-translate
					>No consents.</p>
					<v-list v-else class="mb-5" flat>
						<PreMadeConsentItem
							v-for="consent in info.user_info.space.pre_made_consents"
							:key="consent.id"
							:consent="consent"
							@remove="revomePreMadeConsent"
						/>
					</v-list>
				</div>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="appointment_types" v-if="isManager">
				<AppointmentTypes ref="appTypes" />
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="pricing" v-if="isManager">
				<Billing ref="pricing"/>
			</v-tab-item>
			<v-tab-item :transition="false" :reverse-transition="false" value="email_sms" v-if="isManager">
				<div class="px-4">
					<v-row no-gutters class="mb-3">
						<span class="title font-weight-regular primary--text">
							<translate>Email & SMS</translate>
							<v-btn
								color="primary"
								fab
								x-small
								class="my-1 ml-2"
								@click="showEmailSMSForm = !showEmailSMSForm"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</span>
					</v-row>
					<template v-if="!showEmailSMSForm">
						<p class="mt-3 mb-2">
							<b v-translate>Appointment notification</b>
							<v-chip v-if="!info.user_info.space.send_appointment_notification" class="grey--text ml-1" small>
								<span v-translate>Deactivated</span>
							</v-chip>
						</p>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Notification time</translate>
									</span>
									<span v-if="info.user_info.space.appointment_notification_time === 0" class="grey--text" style="float: right"><translate>Imediato</translate></span>
									<span v-else class="grey--text" style="float: right">{{info.user_info.space.appointment_notification_time}}m <translate>after</translate></span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<p class="mt-3 mb-2">
							<b v-translate>Appointment reminder notification</b>
							<v-chip v-if="!info.user_info.space.send_appointment_reminder_notification" class="grey--text ml-1" small>
								<span v-translate>Deactivated</span>
							</v-chip>
						</p>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Notification time</translate>
									</span>
									<span class="grey--text" style="float: right">{{info.user_info.space.appointment_reminder_notification_time}}h <translate>before</translate></span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<p class="mt-3 mb-2">
							<b v-translate>Notification content</b>
						</p>
						<v-list-item class="mb-1" style="border-radius: 5px; border: 1px solid #e3e3e3">
							<v-list-item-content>
								<v-list-item-title>
									<span>
										<translate>Show Professional's name</translate>
									</span>
									<v-chip class="grey--text ml-1" small style="float: right">
										<span v-if="info.user_info.space.show_professional_name_notification" v-translate>Yes</span>
										<span v-else v-translate>No</span>
									</v-chip>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-form ref="emailSMSForm">
							<v-row no-gutters>
								<v-col cols="12" lg="3" md="5">
									<v-checkbox
										v-model="info.user_info.space.send_appointment_notification"
										:label="$gettext('Send appointment notification')"
										color="primary"
										class="my-0"
									></v-checkbox>
								</v-col>
								<v-col cols="12" lg="3" md="5">
									<v-select
										v-model="info.user_info.space.appointment_notification_time"
										:disabled="!info.user_info.space.send_appointment_notification"
										:items="appointmentNotificationTimes"
										:label="$gettext('Notification time')"
										item-text="name"
										item-value="value"
										outlined
										class="px-2"
									></v-select>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" lg="3" md="5">
									<v-checkbox
										v-model="info.user_info.space.send_appointment_reminder_notification"
										:label="$gettext('Send appointment reminder notification')"
										color="primary"
										class="my-0"
									></v-checkbox>
								</v-col>
								<v-col cols="12" lg="3" md="5">
									<v-select
										v-model="info.user_info.space.appointment_reminder_notification_time"
										:disabled="!info.user_info.space.send_appointment_reminder_notification"
										:items="appointmentReminderNotificationTimes"
										:label="$gettext('Notification time')"
										item-text="name"
										item-value="value"
										outlined
										class="px-2"
									></v-select>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" lg="3" md="5">
									<v-checkbox
										v-model="info.user_info.space.show_professional_name_notification"
										:label="$gettext('Show Professional\'s name')"
										color="primary"
										class="my-0"
									></v-checkbox>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" class="my-2">
									<v-btn color="primary" @click="cancelEditEmailSMS">
										<translate>Cancel</translate>
									</v-btn>
									<v-btn color="primary" class="float-right" @click="editEmailSMS">
										<translate>Save</translate>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</template>
				</div>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import axios from "axios";
import colors from "vuetify/lib/util/colors";
import PatientItem from "@/components/settings/PatientItem.vue";
import SpecialityItem from "@/components/settings/SpecialityItem.vue";
import PreMadeConsentItem from "@/components/settings/PreMadeConsentItem.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";
import Billing from '../../views/app/Billing.vue';
import AppointmentTypes from './AppointmentTypes.vue';

export default {
	name: "General",
	props: ["info"],
	components: {
		PatientItem,
		SpecialityItem,
		RichTextEditor,
		PreMadeConsentItem,
		Billing,
		AppointmentTypes
	},
	data: () => ({
		tabOpen: null,
		logoName: 'generic_logo.png',
		showGeneralForm: false,
		showEmailSMSForm: false,
		showEntityForm: false,
		showPlatformForm: false,
		showPrescriptionForm: false,
		showChangePassword: false,
		changePasswordFormValid: false,
		showChangePasswordError: false,
		showMonitoringForm: false,
		showDataConsentForm: false,
		showNewPremadeConsent: false,
		newPreMadeConsent: {
			title: "",
			consent_text: "",
			consent_minor_text: ""
		},
		current_pwd: "",
		new_pwd: "",
		repeat_pwd: "",
		showNewSpeciality: false,
		newSpecialityName: null,
		prescriptionLogo: null,
		adminLogo: null,
		studentProof: null,
		savingSpeciality: false,
		patientsExcel: null,
		successImport: false,
		numPatientsImported: 0,
		showImportInput: false,
		showImportPatientsInfo: false,
		existPatients: [],
		invalidDatePatients: [],
		loadingImportPatients: false,
		availableLanguages: [
			{ code: "en", name: "English" },
			{ code: "pt", name: "Português" }
		],
		availableHours: [
			{ value: 0, name: "0h00" },
			{ value: 1, name: "1h00" },
			{ value: 2, name: "2h00" },
			{ value: 3, name: "3h00" },
			{ value: 4, name: "4h00" },
			{ value: 5, name: "5h00" },
			{ value: 6, name: "6h00" },
			{ value: 7, name: "7h00" },
			{ value: 8, name: "8h00" },
			{ value: 9, name: "9h00" },
			{ value: 10, name: "10h00" },
			{ value: 11, name: "11h00" },
			{ value: 12, name: "12h00" },
			{ value: 13, name: "13h00" },
			{ value: 14, name: "14h00" },
			{ value: 15, name: "15h00" },
			{ value: 16, name: "16h00" },
			{ value: 17, name: "17h00" },
			{ value: 18, name: "18h00" },
			{ value: 19, name: "19h00" },
			{ value: 20, name: "20h00" },
			{ value: 21, name: "21h00" },
			{ value: 22, name: "22h00" },
			{ value: 23, name: "23h00" },
			{ value: 24, name: "24h00" }
		],
		availableColors: [
			{
				name: "Teal",
				value: "teal"
			},
			// {
			// 	name: "Red",
			// 	value: "red"
			// },
			// {
			// 	name: "Pink",
			// 	value: "pink"
			// },
			{
				name: "Purple",
				value: "purple"
			},
			{
				name: "Deep Purple",
				value: "deep-purple"
			},
			{
				name: "Indigo",
				value: "indigo"
			},
			{
				name: "Blue",
				value: "blue"
			},
			{
				name: "Light Blue",
				value: "light-blue"
			},
			{
				name: "Cyan",
				value: "cyan"
			},
			{
				name: "Green",
				value: "green"
			},
			{
				name: "Light Green",
				value: "light-green"
			},
			// {
			// 	name: "Lime",
			// 	value: "lime"
			// },
			{
				name: "Yellow",
				value: "yellow"
			},
			{
				name: "Amber",
				value: "amber"
			},
			{
				name: "Orange",
				value: "orange"
			},
			{
				name: "Deep Orange",
				value: "deep-orange"
			},
			{
				name: "Brown",
				value: "brown"
			},
			{
				name: "Blue Grey",
				value: "blue-grey"
			},
			{
				name: "Grey",
				value: "grey"
			}
		],
		calendarMin: 10,
		calendarMax: 23,
		calendarMinMenu: false,
		calendarMaxMenu: false,
		showSaturday: true,
		showSunday: false
	}),
	methods: {
		changeColor(reset) {
			let color;
			if (reset) color = this.$store.getters.userPlatformColor;
			else color = this.info.user_info.platform_color.value;
			const words = color.split("-");
			let colorName;
			if (words[1])
				colorName =
					words[0] + words[1].charAt(0).toUpperCase() + words[1].slice(1);
			else colorName = color;
			this.$vuetify.theme.themes.light.primary = colors[colorName];
			this.$vuetify.theme.themes.light.secondary = colors[colorName].lighten5;
			this.$vuetify.theme.themes.light.alert = colors[colorName].lighten2;
			this.info.user_info.platform_color = color;
		},
		editUserInfo() {
			const formData = new FormData();
			formData.append("name", this.info.user_info.name);
			formData.append("space_id", this.info.user_info.space.id);
			formData.append("email", this.info.user_info.email);
			formData.append("phone", this.info.user_info.space.phone ? this.info.user_info.space.phone : '');
			this.info.user_info.specialities.forEach(s => {
				formData.append("specialities", s.id);
			});
			if(this.info.user_info.student) {
				formData.append("school", this.info.user_info.school ? this.info.user_info.school : '');
				formData.append("student_number", this.info.user_info.student_number ? this.info.user_info.student_number : '');
				if(this.studentProof) formData.append("upload-proof", this.studentProof.file);
			}
			formData.append("license_number", this.info.user_info.license_number);
			formData.append("company_name", this.info.user_info.space.company_name ? this.info.user_info.space.company_name : '');
			formData.append("company_nif", this.info.user_info.space.company_nif ? this.info.user_info.space.company_nif : '');
			formData.append("space_name", this.info.user_info.space.space_name ? this.info.user_info.space.space_name : '');
			if (this.adminLogo) {
				formData.append("upload", this.adminLogo.file);
			}
			formData.append("edit_info", true);
			this.$emit("edit-user-info", formData);
			this.showGeneralForm = false;
		},
		editExternalEntity() {
			const form = new FormData();
			form.append("name", this.info.user_info.space.external_entity.name ?? '');
			form.append("address", this.info.user_info.space.external_entity.address ?? '');
			form.append("phone", this.info.user_info.space.external_entity.phone ?? '');
			form.append("email", this.info.user_info.space.external_entity.email ?? '');
			form.append("description", this.info.user_info.space.external_entity.description ?? '');
			form.append("cmm", this.info.user_info.space.external_entity.cmm);
			form.append("supp", this.info.user_info.space.external_entity.supp);
			axios
				.post('/provider', form)
				.then(response => {
					console.log(response.data);
					this.showEntityForm = false;
					this.$store.dispatch('SET_EXTERNAL_ENTITY', this.info.user_info.space.external_entity);
				})
				.catch(error => {
					console.log(error);
				});
		},
		changePassword() {
			if (this.validateChangePassword()) {
				this.showChangePasswordError = false;
				const formData = new FormData();
				formData.append("current_pwd", this.current_pwd);
				formData.append("new_pwd", this.new_pwd);
				formData.append("repeat_pwd", this.repeat_pwd);
				formData.append("change_password", true);

				axios
					.post("/settings", formData)
					.then(response => {
						if (response.data.result === "ok") {
							this.showChangePassword = false;
						} else {
							this.showChangePasswordError = true;
						}
						this.current_pwd = "";
						this.new_pwd = "";
						this.repeat_pwd = "";
						this.$refs.changePasswordForm.reset();
					})
					.catch(error => {
						console.log(error);
						this.showChangePasswordError = true;
					});
			}
		},
		validateChangePassword() {
			return this.$refs.changePasswordForm.validate();
		},
		removeAdminLogo() {
			const formData = new FormData();
			formData.append("remove_logo_admin", true);
			this.$emit("edit-user-info", formData);
		},
		fileSelected(fileRecord, logo) {
			console.log(fileRecord);
			if(!fileRecord[0].error) {
				if(logo) this.adminLogo = fileRecord[0];
				else this.studentProof = fileRecord[0];
			}
		},
		removePrescriptionLogo() {
			const formData = new FormData();
			formData.append("remove_logo_prescription", true);
			this.$emit("edit-user-info", formData);
		},
		editPlatform() {
			if(this.$refs.platformForm.validate()) {
				const formData = new FormData();
				formData.append("language", this.info.user_info.language);
				formData.append("platform_color", this.info.user_info.platform_color);
				formData.append("calendar_min", this.info.user_info.calendar_min);
				formData.append("calendar_max", this.info.user_info.calendar_max);
				formData.append("calendar_show_saturday", this.info.user_info.show_saturday);
				formData.append("calendar_show_sunday", this.info.user_info.show_sunday);
				if(this.$store.getters.hasRole('manager')) {
					formData.append("app_duration_interval", this.info.user_info.space.app_duration_interval);
					formData.append("auto_drug_import", this.info.user_info.space.auto_drug_import);
				}
				formData.append("save_platform", true);
				this.$emit("edit-user-info", formData);
				this.showPlatformForm = false;
			}
		},
		cancelEditPlatform() {
			this.showPlatformForm = false;
			this.changeColor(true);
		},
		editPrescription() {
			const formData = new FormData();
			formData.append(
				"prescription_email",
				this.info.prescription_info.prescription_email
			);
			formData.append(
				"prescription_header",
				this.info.prescription_info.prescription_header
			);
			formData.append(
				"prescription_footer",
				this.info.prescription_info.prescription_footer
			);
			formData.append(
				"prescription_letterhead",
				this.info.prescription_info.prescription_letterhead
			);
			if (this.info.prescription_info.prescription_letterhead) {
				formData.append(
					"prescription_letterhead_height",
					this.info.prescription_info.prescription_letterhead_height
				);
			}
			if (this.prescriptionLogo) {
				formData.append("prescription_upload", this.prescriptionLogo.file);
			}
			formData.append("save_prescription", true);
			this.$emit("edit-user-info", formData);
			this.showPrescriptionForm = false;
		},
		editMonitoring() {
			const formData = new FormData();
			formData.append(
				"monitoring_email_body",
				this.info.user_info.monitoring_email_body
			);
			formData.append("save_monitoring", true);
			this.$emit("edit-user-info", formData);
			this.showMonitoringForm = false;
		},
		editDataConsent() {
			const formData = new FormData();
			formData.append("data_consent_text",this.$refs.dataConsentOlder.getHTML());
			formData.append("data_consent_minor_text",this.$refs.dataConsentMinor.getHTML());
			formData.append("save_data_consent", true);
			this.$emit("edit-user-info", formData);
			this.showDataConsentForm = false;
		},
		addSpeciality() {
			if (this.validateSpeciality()) {
				this.savingSpeciality = true;
				const formData = new FormData();
				formData.append("new_specialty", this.newSpecialityName);
				formData.append("save_speciality", true);
				this.$emit("edit-user-info", formData);
				this.newSpecialityName = null;
				this.showNewSpeciality = false;
				this.savingSpeciality = false;
			}
		},
		validateSpeciality() {
			return this.$refs.newSpecialityForm.validate();
		},
		removeSpeciality(speciality) {
			this.$emit("remove-speciality", speciality);
		},
		importPatients() {
			this.numPatientsImported = 0;
			this.loadingImportPatients = true;
			this.successImport = false;
			this.existPatients = [];
			this.invalidDatePatients = [];
			if (this.$refs.importPatientsForm.validate()) {
				console.log(this.patientsExcel);
				const formData = new FormData();
				if (this.patientsExcel) {
					formData.append("patients_excel", this.patientsExcel);
				}
				axios
					.post("/patients/import", formData)
					.then(response => {
						console.log(response.data);
						this.loadingImportPatients = false;
						if (response.data.result === "ok") {
							this.numPatientsImported = response.data.num_patients;
							this.existPatients = response.data.exist_name;
							this.invalidDatePatients = response.data.patients_invalid;
							this.showImportInput = false;
							this.successImport = true;
						}
					})
					.catch(error => {
						console.log(error);
						this.loadingImportPatients = false;
						this.successImport = true;
					});
			}
		},
		downloadTemplate() {
			var link = document.createElement("a");
			var lang = this.$store.getters.userLanguage;
			var fileName = "";
			if (lang == "pt") {
				fileName = "importar_pacientes_modelo.xlsx";
				link.download = "importar_pacientes_modelo.xlsx";
			} else {
				fileName = "import_patients_template.xlsx";
				link.download = "import_patients_template.xlsx";
			}
			link.href = process.env.BASE_URL + fileName;
			document.body.appendChild(link);
			link.click();
		},
		deletePatient(patient) {
			axios
				.post("/patient/" + patient.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						if (response.data.result === "deleted") {
							this.info.deleted_patients.splice(
								this.info.deleted_patients.indexOf(patient),
								1
							);
						}
					}
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
				});
		},
		restorePatient(patient) {
			axios
				.post("/patient/" + patient.id + "/change-status")
				.then(response => {
					console.log(response.data);
					if (response.status === 200) {
						this.info.deleted_patients.splice(
							this.info.deleted_patients.indexOf(patient),
							1
						);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		createPreMadeConsent() {
			if(this.$refs.newPreMadeConsentForm.validate()) {
				const formData = new FormData();
				formData.append("title", this.newPreMadeConsent.title);
				formData.append("consent_text", this.$refs.editorPreMadeOlder.getHTML());
				formData.append("consent_minor_text", this.$refs.editorPreMadeMinor.getHTML());
				formData.append("new_pre_made_consent", true);
				this.$emit("edit-user-info", formData);
				this.showNewPremadeConsent = false;
			}
		},
		revomePreMadeConsent(consent) {
			this.info.user_info.space.pre_made_consents.splice(this.info.user_info.space.pre_made_consents.indexOf(consent), 1);
		},
		openFile(code) {
			axios
				.get("/download/" + code)
				.then(response => {
					if (response.status === 200) {
						var link = document.createElement("a");
            link.href = "https://api.naltio.com/download/" + code;
            //link.href = "http://127.0.0.1:5500/download/" + code;
						link.target = "_self";
						document.body.appendChild(link);
						link.click();
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		removeProof() {
			const formData = new FormData();
			formData.append("remove_student_proof", true);
			this.$emit("edit-user-info", formData);
		},
		cancelEditEmailSMS() {
			this.showEmailSMSForm = false;
		},
		editEmailSMS() {
			if(this.$refs.emailSMSForm.validate()) {
				const formData = new FormData();
				formData.append("send_appointment_notification", this.info.user_info.space.send_appointment_notification);
				formData.append("send_appointment_reminder_notification", this.info.user_info.space.send_appointment_reminder_notification);
				formData.append("appointment_notification_time", this.info.user_info.space.appointment_notification_time);
				formData.append("appointment_reminder_notification_time", this.info.user_info.space.appointment_reminder_notification_time);
				formData.append("show_professional_name_notification", this.info.user_info.space.show_professional_name_notification);
				formData.append("save_email_sms", true);
				this.$emit("edit-user-info", formData);
				this.showEmailSMSForm = false;
			}
		}
	},
	computed: {
		availableMinHours() {
			if (this.info.user_info.calendar_max) {
				var hours = [];
				this.availableHours.forEach(h => {
					if (h.value < this.info.user_info.calendar_max) hours.push(h);
				});
				return hours;
			} else {
				return this.availableHours;
			}
		},
		availableMaxHours() {
			if (this.info.user_info.calendar_min) {
				var hours = [];
				this.availableHours.forEach(h => {
					if (h.value > this.info.user_info.calendar_min) hours.push(h);
				});
				return hours;
			} else {
				return this.availableHours;
			}
		},
		passwordRule() {
			return v =>
				(v && v.length >= 8) ||
				this.$gettext("Password must have at least 8 characters");
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		},
		isInteger() {
			return value => Number.isInteger(Number(value)) || this.$gettext("Invalid.");
		},
		emailRule() {
			return value => {
				const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return pattern.test(value) || this.$gettext("Invalid e-mail.");
			};
		},
		languageName() {
			if (this.info.user_info.language === "pt") return "Português";
			else return "English";
		},
		equalTo() {
			return v => v === this.new_pwd || this.$gettext("Passwords must match");
		},
		isManager() {
			return !this.$store.getters.isExternalEntity && this.$store.getters.hasRole('manager');
		},
		isTerapeut() {
			return !this.$store.getters.isExternalEntity && this.$store.getters.hasRole('terapeut');
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		appointmentNotificationTimes() {
			return [
				{ value: 0, name: this.$gettext("Imediato")},
				{ value: 3, name: `3m ${this.$gettext("after")}`},
				{ value: 5, name: `5m ${this.$gettext("after")}`},
				{ value: 10, name: `10m ${this.$gettext("after")}`},
			];
		},
		appointmentReminderNotificationTimes() {
			return [
				{ value: 24, name: `24h ${this.$gettext("before")}`},
				{ value: 48, name: `48h ${this.$gettext("before")}`},
				{ value: 72, name: `72h ${this.$gettext("before")}`}
			];
		}
	},
	watch: {
		tabOpen(value) {
			if(value == 'appointment_types' && this.$refs.appTypes) {
				this.$refs.appTypes.init();
			}
			if(value == 'pricing' && this.$refs.pricing) {
				this.$refs.pricing.init();
			}
		}
	}
};
</script>

<style scoped>
.v-tab {
	justify-content: left !important;
	min-width: 240px;
}
.v-slide-group__wrapper {
	box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08) !important;
	margin-right: 10px !important;
}
</style>